import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nlf-club',
  templateUrl: './club.component.html',
  styleUrls: ['./club.component.css']
})
export class NlfClubComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
